export default __webpack_public_path__ + "static/media/Medication Options.70e1bdbe.png";